module.exports = __webpack_public_path__ + "static/media/scrambler-wp.8fa9f4e5.jpg";